import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { apiErr } from "./SuperHeader";

// Small fetch hook for super admin tabs: returns {data, error, loading, reload}
export function useAdminFetch(url, params) {
  const [state, setState] = useState({ data: null, error: null, loading: true });
  const key = JSON.stringify(params || {});
  const reload = () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    api.get(url, { params }).then((r) => setState({ data: r.data, error: null, loading: false }))
      .catch((e) => setState({ data: null, error: apiErr(e), loading: false }));
  };
  useEffect(reload, [url, key]); // eslint-disable-line react-hooks/exhaustive-deps
  return { ...state, reload };
}

export function TabState({ loading, error, empty, emptyText = "Nothing here yet.", children, testid }) {
  if (error) return <div className="p-8 text-center text-sm text-rose-700" data-testid={`${testid}-error`}>{error}</div>;
  if (loading) return <div className="p-8 text-center text-sm text-slate-500" data-testid={`${testid}-loading`}>Loading…</div>;
  if (empty) return <div className="p-8 text-center text-sm text-slate-500" data-testid={`${testid}-empty`}>{emptyText}</div>;
  return children;
}

export function Stat({ label, value, testid }) {
  return (
    <div className="p-3 bg-slate-50 rounded-lg border border-slate-100">
      <div className="text-xl font-bold text-slate-900" data-testid={testid}>{value ?? 0}</div>
      <div className="text-xs text-slate-500">{label}</div>
    </div>
  );
}
